module.exports = __webpack_public_path__ + "img/Feature.b3855752.png";